import { validationMessages } from '../../../app/utils/validationMessages';

const pcsPlanFormModel = {
  formId: 'PcaAnnualPlanForm',
  formField: {
    StartDate: {
      name: 'StartDate',
      label: 'Start date'
    },
    PostLevel: {
      name: 'PostLevel',
      label: 'Post level'
    },
    NameOfEmployer: {
      name: 'NameOfEmployer',
      label: 'Name of employer'
    },
    AnnualPlanStatus: {
      name: 'AnnualPlanStatus',
      label: 'Annual plan status'
    },
    AccreditedContinuingEducationActivity: {
      name: 'AccreditedContinuingEducationActivity',
      label: 'Accredited Continuing Education (CE) Activity*',
      maxStringCount: 3000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    WorkBasedLearning: {
      name: 'WorkBasedLearning',
      label: 'Work based learning*',
      maxStringCount: 3000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    PracticeReview: {
      name: 'PracticeReview',
      label: 'Practice review*',
      maxStringCount: 3000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    EngagedInPracticeOfMedicine: {
      name: 'engagedInPracticeOfMedicine'
    },
    FirstName: {
      name: 'FirstName',
      label: 'First name*',
      maxStringCount: 50,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Surname: {
      name: 'Surname',
      label: 'Surname*',
      maxStringCount: 50,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Name: {
      name: 'Name',
      label: 'Name'
    },
    Title: {
      name: 'Title',
      label: 'Title*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    IMCNumber: {
      name: 'IMCNumber',
      label: 'IMC number*',
      maxStringCount: 6,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get minErrorMessage(): string {
        return `${this.label.replace('*', '')} must be at least 6 digits.`;
      },
      get maxErrorMessage(): string {
        return `${this.label.replace('*', '')} must be no more than ${this.maxStringCount} digits.`;
      },
      noSelfImcNumberErrorMessage: 'You can\'t add yourself as a reviewer.',
    },
    EmailAddress: {
      name: 'EmailAddress',
      label: 'Email address',
      maxStringCount:50,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    ReviewerComments: {
      name: 'ReviewerComments',
      label: 'Reviewer feedback',
      maxStringCount: 2500,
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    MyReflection: {
      name: 'MyReflection',
      label: 'My reflection*',
      maxStringCount: 2500,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  }
};

export default pcsPlanFormModel;